import React from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import './GetInTouch.css';
import { Link } from 'react-router-dom';

export default () => (
  <div>
    <Grid>
      <Row className="get-in-touch">
        <Col md={8} xs={12} className="content-col">
          <h3> We can do this for you too</h3>
          <h5 className="blurb" >
            Get in touch with us so we can help you get closer to your customers
          </h5>
        </Col>
        <Col md={4} xs={12} className="button-col">
          <Link to="/contact">
            <Button bsClass="button">GET IN TOUCH</Button>
          </Link>
        </Col>
      </Row>
    </Grid>
    <hr className="rule" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/GetInTouch.js